module.exports = __webpack_public_path__ + "media/coin-sound.a1308090.mp3";